import {Component, inject, OnInit} from '@angular/core';
import {CommonModule, Location} from '@angular/common';
import {ActivatedRoute} from "@angular/router";
import {
    DxButtonModule,
    DxLoadPanelModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxValidationGroupModule,
    DxValidatorModule,
    DxScrollViewModule,
    DxNumberBoxModule
} from "devextreme-angular";
import {
    StorageType,
    InventoryClient,
    HalbDto,
    UpdateHalbCommand
} from '@services';
import notify from "devextreme/ui/notify";
import EnumUtils from "../../../../shared/enum-utils";

@Component({
  selector: 'app-halb-details',
    imports: [
        CommonModule,
        DxToolbarModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxValidationGroupModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxSelectBoxModule,
        DxScrollViewModule,
        DxNumberBoxModule
    ],
  templateUrl: './halb-details.component.html',
  styleUrl: './halb-details.component.scss',
})
export class HalbDetailsComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private location = inject(Location);
    private inventoryClient = inject(InventoryClient);

    protected halbNumber: string | null = null;
    protected halb: HalbDto = new HalbDto();
    protected isLoading = false;
    protected storageTypeOptions = EnumUtils.getEnumOptions(StorageType);
    protected materialGroupOptions = [
        'Bars',
        'Seasonal',
        'Nescafe',
        'Beverage',
        'Starbucks CPG',
        'Infant',
        'NHS',
        'Specialty Foods',
        'NP / Import',
        'Starbucks FS',
        'Water',
        'Ice Cream',
        'Others'
    ];

    ngOnInit(): void {
        this.halbNumber = this.route.snapshot.paramMap.get('number');
        if (this.halbNumber) {
            this.loadHalb();
        } else {
            notify('Halb Number missing', 'error', 3000);
            this.cancel();
        }
    }

    private loadHalb() {
        this.isLoading = true;
        this.inventoryClient.getHalb(this.halbNumber!).subscribe({
            next: (data) => {
                this.halb = data;
                this.isLoading = false;
            },
            error: () => {
                notify('Failed to load Halb', 'error', 3000);
                this.isLoading = false;
                this.location.back();
            }
        });
    }

    save() {
        const command = new UpdateHalbCommand({
            number: this.halbNumber!,
            revisedStorageType: this.halb.storageType,
            materialGroup: this.halb.materialGroup
        });

        this.inventoryClient.updateHalb(command).subscribe({
            next: () => {
                notify('Halb updated successfully', 'success', 3000);
            },
            error: () => {
                notify('Failed to update Halb', 'error', 3000);
            }
        });
    }

    cancel() {
        this.location.back();
    }
}

